import React, { useMemo } from "react"
import { t } from "i18next"
import theme from "utils/themeVars"
import InsightInfoCard from "../../../../../eventDetails/components/insights/components/insightInfoCard/insightInfoCard"
import { Col, Flex, Row } from "antd"
import { BarChart, LineChart } from "components/charts"
import { Card, Text } from "components/common"
import styles from "../../index.module.less"

const ChatInsights = ({ insights, loading }) => {
  const overviewInfo = useMemo(
    () => [
      {
        icon: "IoMdTime",
        title: t("Response Time (Staff | Client)"),
        type: "text",
        value: insights?.averageResponseTime?.staff,
        color: "#0091BA",
        bgColor: "#E6F5F9",
        secondaryItems: [
          {
            value: insights?.averageResponseTime?.client,
          },
        ],
      },
      {
        icon: "FiMessageCircle",
        title: t("Staff to Client Message Ratio"),
        type: "text",
        value: insights?.messageDistribution?.ratio,
        color: "#0091BA",
        bgColor: "#E6F5F9",
      },
    ],
    [insights]
  )

  return (
    <Flex gap={28} vertical>
      <Row className={styles.summaryCard} gutter={[8]}>
        {overviewInfo?.map(item => (
          <Col span={12}>
            <InsightInfoCard
              cardProps={{ bodyStyle: { padding: "12px" } }}
              iconProps={{ size: "20px" }}
              numberProps={{ style: { fontSize: 14 } }}
              key={item.id}
              item={item}
            />
          </Col>
        ))}
      </Row>
      {!!(insights?.engagementScores?.length > 1) && (
        <Card className={styles.basicCard} bodyStyle={{ padding: "16px" }}>
          <Text className="mbe-20 semiBold">{t("Engagement Score")}</Text>
          <LineChart
            data={insights?.engagementScores || []}
            xField={"date"}
            yField={"score"}
            maxColumnWidth={20}
            loading={loading}
            disabled={loading}
            height={252}
            xAxis={{
              title: { text: t("Engagement") },
            }}
            color={["#4667D3", theme["error-color"]]}
          />
        </Card>
      )}
      {!!insights?.mediaDistribution?.length > 0 && (
        <Card className={styles.basicCard} bodyStyle={{ padding: "16px" }}>
          <Text className="mbe-20 semiBold">{t("Media Distribution")}</Text>
          <BarChart
            data={insights?.mediaDistribution || []}
            xField={"label"}
            yField={"count"}
            maxColumnWidth={20}
            loading={loading}
            disabled={loading}
            height={252}
            xAxis={{
              title: { text: t("Count") },
            }}
            color={["#4667D3", theme["error-color"]]}
          />
        </Card>
      )}
    </Flex>
  )
}

export default ChatInsights
